module.exports = __webpack_public_path__ + "static/media/rsm-checkmark.0c3a4e09.svg";